import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { ConfigContext } from '../ConfigContext';

export const AuthContext: React.FC = ({ children }) => {
  const config = ConfigContext.useContainer();

  return config ? (
    <Auth0Provider
      clientId={config.auth0.client_id}
      domain={config.auth0.domain}
      authorizationParams={{
        audience: config.auth0.audience,
        redirect_uri: config.auth0.redirect_uri,
        scope: config.auth0.scope,
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  ) : null;
};
